// eslint-disable-next-line no-restricted-imports -- Required for Node.js script compatibility (routesMetadata.config.js)
import { TABLE_COLUMN_DEFINITIONS, TABLE_COL_NAMES } from './table-cell.const.js'

// Ticket Status Constants
export const TICKET_STATUS = {
  OPENED: 'opened', // Draft - not yet submitted
  PREPROCESS: 'preprocess', // Submitted, initial processing
  PROCESSING: 'processing', // Under review by admin
  CLOSED: 'closed', // Review complete (approved or denied)
}

export const DIRECTORIES = {
  inReview: 'in-review',
  approved: 'approved',
  denied: 'denied',
  drafts: 'drafts',
}

export const TICKET_DIRECTORIES = [
  { id: DIRECTORIES.inReview, label: 'Under review', icon: 'clipboard-clock' },
  { id: DIRECTORIES.approved, label: 'Approved', icon: 'badge-check' },
  { id: DIRECTORIES.denied, label: 'Denied', icon: 'badge-x' },
  { id: DIRECTORIES.drafts, label: 'Draft', icon: 'file-edit' },
]

export const TICKET_FILTER_FIELDS = {
  search: '', // string
  dateRange: null, // '1d', '1w', '1m', '3m', 'all'
  status: DIRECTORIES.inReview, // 'in-review', 'approved', 'denied', 'drafts'
}

export const TICKET_SORT_PAGINATION_FIELDS = {
  sortBy: TABLE_COL_NAMES.DATE_SUBMITTED,
  descending: true,
  page: 1,
  rowsPerPage: 15,
}

export const DRAFTS_SORT_FIELDS = {
  sortBy: TABLE_COL_NAMES.DATE_CREATED,
  descending: true,
}

export const DEFAULT_FILTER_SORT = {
  ...TICKET_SORT_PAGINATION_FIELDS,
  ...TICKET_FILTER_FIELDS,
}

export const DATE_RANGE_OPTIONS = [
  { label: 'All time', value: null },
  { label: 'Last Week', value: '1w' },
  { label: 'Last Month', value: '1m' },
  { label: 'Last 3 Months', value: '3m' },
  { label: 'Last 6 Months', value: '6m' },
]

export const TICKET_COLUMNS = [
  TABLE_COLUMN_DEFINITIONS.productName,
  TABLE_COLUMN_DEFINITIONS.dateCreated,
  TABLE_COLUMN_DEFINITIONS.dateSubmitted,
]

export const TICKET_TABS = {
  information: {
    name: 'information',
    label: 'Information',
    icon: 'info',
  },
  details: {
    name: 'details',
    label: 'Details',
    icon: 'list',
  },
  attachments: {
    name: 'attachments',
    label: 'Attachments',
    icon: 'paperclip',
  },
  messages: {
    name: 'messages',
    label: 'Messages',
    icon: 'message-circle',
  },
}

export const TICKET_STATUS_CONFIG = {
  approved: {
    type: 'approved',
    label: 'Approved',
    icon: 'badge-check',
    color: 'positive',
    textColor: 'surface',
    title: 'Your request has been approved',
    detailLabel: 'Approval conditions',
  },
  denied: {
    type: 'denied',
    label: 'Denied',
    icon: 'badge-x',
    color: 'negative',
    textColor: 'surface',
    title: 'Your request has been denied',
    detailLabel: 'Deny Reason',
    message: 'This request has been denied by system admins.',
  },
  processing: {
    type: 'in-review',
    label: 'Under review',
    icon: 'clipboard-clock',
    color: 'cta',
    textColor: 'primary',
    title: 'Your request is under review',
    detailLabel: null,
  },
  draft: {
    type: 'draft',
    label: 'Draft',
    icon: 'file-edit',
    color: 'accent',
    textColor: 'primary',
    title: 'Draft Request',
    message: 'This request is still a draft. Complete and submit it to start the review process.',
  },
}

export const DUPLICATE_TICKET_CONFIG = {
  revoked: {
    statusTitle: 'This product approval has been revoked.',
    statusSubtitle: 'A new draft request will be created based on your previous submission.',
  },
  denied: {
    statusTitle: 'This product request has been denied.',
    statusSubtitle: 'A new draft request will be created based on your previous submission.',
  },
}

// Question Types
export const QUESTION_TYPES = {
  TEXT: 'text',
  YES_NO: 'yes_no',
  SINGLE_SELECT: 'single_select',
  MULTIPLE_SELECT: 'multiple_select',
  FILE_UPLOAD: 'file_upload',
}

export const QUESTION_TYPE_HINTS = {
  [QUESTION_TYPES.YES_NO]: 'Select one option',
  [QUESTION_TYPES.SINGLE_SELECT]: 'Select one option',
  [QUESTION_TYPES.MULTIPLE_SELECT]: 'Select all options that apply',
  [QUESTION_TYPES.FILE_UPLOAD]: 'Attach one or more files',
}

export const OPTION_QUESTION_TYPES = [
  QUESTION_TYPES.YES_NO,
  QUESTION_TYPES.SINGLE_SELECT,
  QUESTION_TYPES.MULTIPLE_SELECT,
]

// File upload restrictions
export const FILE_UPLOAD_LIMIT_MB = 45

// Restricted file extensions for security (blocked from Google Cloud Storage)
export const RESTRICTED_FILE_EXTENSIONS = [
  // Executable files
  '.exe',
  '.bat',
  '.cmd',
  '.com',
  '.pif',
  '.scr',
  '.vbs',
  '.jar',
  '.app',
  '.deb',
  '.rpm',
  '.msi',
  '.dmg',
  '.apk',
  '.ipa',
  // Script files
  '.sh',
  '.ps1',
  '.psm1',
  '.psd1',
  '.py',
  '.pyc',
  '.pyo',
  '.pyd',
  '.rb',
  '.pl',
  '.js', // Standalone JavaScript files (not web assets)
  '.jsx',
  '.ts',
  '.tsx',
  // System/library files
  '.dll',
  '.so',
  '.dylib',
  '.sys',
  '.drv',
  // Potentially dangerous
  '.html',
  '.htm',
  '.xhtml',
  '.swf',
  '.fla',
]
